export enum InstanceStatus {
	Provisioning = "Provisioning",
	ProvisioningFailed = "ProvisioningFailed",
	Live = "Live",
	CustomizationFailed = "CustomizationFailed",
	Deactivated = "Deactivated",
	Deleted = "Deleted",
	Deleting = "Deleting",
	Deactivating = "Deactivating"
}